/*jshint esversion: 6 */
import React from 'react';
import { connect } from 'react-redux';
import { SocialActions } from 'app/redux/actions.js';

function mapStateToProps(state) {
    return({
        socials: state.socials
    });
}

function mapDispatchToProps(dispatch) {
    return {
        getSocials: (force) => {
            dispatch(SocialActions.fetchSocials(force));
        },
        getSocial: (id) => {
            dispatch(SocialActions.fetchSocial(id));
        },
        updateSocial: (social) => {
            dispatch(SocialActions.updateSocial(social));
        },
        deleteSocial: (id) => {
            dispatch(SocialActions.deleteSocial(id));
        },
        createSocial: (social) => {
            dispatch(SocialActions.createSocial(social));
        },
        getSocialLog: (id) => {
            dispatch(SocialActions.fetchSocialLog(id));
        },
        checkAuth: (id) => {
            dispatch(SocialActions.checkSocialAuth(id));
        },
        getSocialTypes: () => {
            dispatch(SocialActions.fetchSocialTypes());
        },
        getSocialTypeDefaults: (id) => {
            dispatch(SocialActions.fetchSocialTypeDefaults(id));
        },
        getQueueCount: (id) => {
            dispatch(SocialActions.fetchQueueCount(id));
        },
        getFacebookGroupStatus: (data) => {
            dispatch(SocialActions.fetchFacebookGroupStatus(data));
        },
        createBatchSocials: (data) => {
            dispatch(SocialActions.createBatchSocials(data));
        },
        createBatchPoll: (data) => {
            dispatch(SocialActions.createBatchPoll(data));
        },
        getYouTubeCategories: (id) => {
            dispatch(SocialActions.fetchYouTubeCategories(id));
        },
        getYouTubePlaylists: (id) => {
            dispatch(SocialActions.fetchYouTubePlaylists(id));
        },
        getPostAnalytics: (data) => {
            dispatch(SocialActions.fetchSocialPostAnalytics(data));
        }
	};
}

export default function SocialProvider(Component) {

    class SocialProvider extends React.Component {
        constructor(props) {
            super(props);

            this.findSocial = this.findSocial.bind(this);
            this.isDuplicateSocial = this.isDuplicateSocial.bind(this);
            this.isBlacklisted = this.isBlacklisted.bind(this);
            this.isOverTheLimit = this.isOverTheLimit.bind(this);
            this.getErrorForSocial = this.getErrorForSocial.bind(this);

        }

        findSocial(id) {
            let social = null;

            for (let i = 0; i < this.props.socials.list.length; ++i) {
                if (parseInt(this.props.socials.list[i].id, 10) === parseInt(id, 10)) {
                    social = this.props.socials.list[i];
                    break;
                }
            }

            return social;

        }

        isDuplicateSocial() {
            let errors = [];

            errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);

            if (errors.length) {
                for (let i = 0; i < errors.length; ++i) {
                    if (errors[i].errors.perms !== undefined && errors[i].errors.perms.code === 2012) {
                        return true;
                    }
                }
            }

            return false;

        }

        isBlacklisted() {
            let errors = [];

            errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);

            if (errors.length) {
                for (let i = 0; i < errors.length; ++i) {
                    if (errors[i].errors !== undefined &&
                        errors[i].errors.creds !== undefined &&
                        errors[i].errors.creds === "Social is not allowed") {
                        return true;
                    }
                }
            }

            return false;
        }

        isOverTheLimit() {
            let errors = [];

            errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);

            if (errors.length) {
                for (let i = 0; i < errors.length; ++i) {
                    if (errors[i].errors.perms !== undefined && Number.isInteger(errors[i].errors.perms.code) && errors[i].errors.perms.code !== 2012) {
                        return true;
                    }
                }
            }

            return false;
        }

        getErrorForSocial(id) {
            let errors = [];

            errors = this.props.getApiErrors(['SOCIAL_CREATE', 'SOCIAL_UPDATE']);

            for (let i = 0; i < errors.length; ++i) {
				if (errors[i].errors[id]) {
					return errors[i].errors;
				}
			}

            return null;
        }

        render() {
            return (
                <Component
                    {...this.props}
                    findSocial={this.findSocial}
                    isDuplicateSocial={this.isDuplicateSocial}
                    isBlacklisted={this.isBlacklisted}
                    isOverTheLimit={this.isOverTheLimit}
                    getErrorForSocial={this.getErrorForSocial}/>
            );
        }
    }

    SocialProvider.displayName = "SocialProvider";

    return connect(mapStateToProps, mapDispatchToProps)(SocialProvider);
};
